export default {
    pageTitle: 'Movoto: casas en venta, listados, agentes, valoración de viviendas, venta de su casa',
    pageDesp: 'Movoto Real Estate: La fuente más confiable para ayudarlo a comprar o vender una casa en la MLS. Busque casas en venta y aprenda sobre las escuelas locales, la demografía y las tendencias del mercado.',
    movotorealestatelistings: 'Movoto listados de bienes raíces',
    homesforsalebystate: 'Casas en venta por estado',
    stateRealEstate: 'Bienes raíces en $state',
    homesForSaleInState: 'Casas en venta en $state',
    popularLocations: 'Ubicaciones populares',
    buy: 'Comprar',
    aHome: 'una casa',
    buyAHome: 'Comprar una casa',
    sell: 'Vender',
    myHome: 'mi casa',
    sellHome: 'Vender mi casa',
    homeEstimate: 'Valoración de vivienda',
    BuyText: 'Ciudad, código postal, escuela, dirección, vecindario...',
    sellMyHomeText: 'mi dirección de casa',
    PriceMyHomeText: 'Ingrese dirección de casa...',
    weSupportYourHome: 'Acompañamos tu viaje a casa, estés donde estés.',
    submit: 'Entregar',
    RecentDesp: 'Visto recientemente',
    actionItems: {
        buy: {
            title: 'Comprar una casa',
            description: 'Búsqueda personalizada, información inteligente y agentes expertos a tu alcance.',
            cta: 'Explorar casas',
        },
        sell: {
            title: 'Vende tu casa',
            description: 'Agentes expertos y herramientas inteligentes para ayudarte a vender más rápido y de forma más inteligente.',
            cta: 'Conéctate',
        },
        finance: {
            title: 'Obtener financiamiento',
            description: 'Herramientas financieras y prestamistas para obtener una aprobación previa rápidamente.',
            cta: 'Obtener aprobación previa',
        },
    },
    bottomCards: {
        guide: {
            title: 'Guía de vecindarios',
            description: 'Todo lo que necesitas saber sobre los vecindarios.',
            link: 'Ver guías',
        },
        marketTrends: {
            title: 'Tendencias del mercado',
            description: 'Explora cómo varían las tendencias de un mercado a otro.',
            link: 'Ver tendencias',
        },
        schools: {
            title: 'Escuelas',
            description: 'Encuentra áreas con los mejores distritos y escuelas.',
            link: 'Ver escuelas',
        },
        tips: {
            title: 'Consejos inmobiliarios',
            description: 'Descubre todos los consejos, trucos y guías sobre bienes raíces.',
            link: 'Ver consejos',
        },
    },
    welcomeHomeIsCloser: 'Bienvenido a casa está más cerca de lo que piensas',
    withCustomizableSearch:
        'Con capacidades de búsqueda personalizables, información habilitada por tecnología y orientación experta, Movoto te brinda las herramientas y el apoyo que necesitas para sentirte seguro al dar tu próximo paso.',
    localLicensedVetted: 'Local, con licencia, verificado',
    yourMovotoAgentWillHelp:
        'Tu agente de Movoto te ayudará a crear una oferta ganadora en la casa adecuada para ti y te apoyará durante todo el proceso, desde la inspección y tasación hasta el cierre.',
    getConnected: 'Conéctate',
    findOutWhatYouCanAfford: 'Descubre lo que puedes pagar',
    understandHowMuchYou:
        'Comprende cuánto puedes pagar con nuestra suite de herramientas financieras y conéctate con un prestamista destacado para obtener la preaprobación, para que estés listo para hacer una oferta cuando sea el momento adecuado.',
    calculateMortgage: 'Calcular hipoteca',
    beTheFirstToKnow: 'Sé el primero en saberlo',
    customizeYourSearchAround: 'Personaliza tu búsqueda en torno a lo que más importa. Te enviaremos actualizaciones de listados en tiempo real para que nunca pierdas una casa que se ajuste.',
    getNotified: 'Recibe notificaciones',
    yourNewHomeMightBe: 'Tu nueva casa podría estar esperándote en una de estas ciudades populares.',
    selectACityToExplore: 'Selecciona una ciudad para explorar las casas disponibles.',
    homesForSaleInCityState: 'Casas en venta en $city, $state',
};
